/* ==========================================================================
   Supra collection — IN-STOCK size narrowing (client-side, post-server-filter)
   --------------------------------------------------------------------------
   Shopify's URL filter `?filter.v.option.size=US W 10` returns every product
   that HAS a US W 10 variant — including ones where that size is sold out.
   Shoppers expect the opposite: clicking a size should narrow to products
   where THAT size is actually buyable.

   This script reads the active size filter values from the URL, then hides
   product cards where the requested size variant isn't in stock. Each card
   already exposes data-supra-sizes-{mens|womens|kids|clothing}-instock
   pipe-lists from supra-product-card.liquid.

   For brand-aware women's equivalency: when shoppers click a women's size
   chip, the sidebar JS appends equivalent men's sizes per brand to the URL.
   This script honors that union — a card matches if ANY of the requested
   sizes (across any bucket) is in stock for that card.
   ========================================================================== */
(function () {
  'use strict';

  var grid = document.querySelector('[data-supra-coll-grid]');
  if (!grid) return;

  var url = new URL(window.location.href);
  var sizeParams = url.searchParams.getAll('filter.v.option.size');
  if (!sizeParams.length) return; // no size filter active, leave grid alone

  // Parse each requested size into ALL applicable buckets + values.
  // Returns an array because combo labels like "US 5Y / 6.5W" map to
  // multiple buckets (kids 5Y, mens 5, womens 6.5).
  function parseSize(label) {
    var up = String(label || '').trim().toUpperCase().replace(/^US /, '');
    var out = [];
    // Combo: split on " / " and parse each part
    var parts = up.split(' / ');
    parts.forEach(function (rawPart) {
      var p = rawPart.trim();
      if (p.indexOf('M ') === 0) {
        out.push({ bucket: 'mens', value: p.slice(2).trim() });
      } else if (p.indexOf('W ') === 0) {
        out.push({ bucket: 'womens', value: p.slice(2).trim() });
      } else if (/W$/.test(p) && !/^GREY$/i.test(p)) {
        out.push({ bucket: 'womens', value: p.replace(/W$/, '').trim() });
      } else if (p.indexOf('GS ') === 0) {
        out.push({ bucket: 'kids', value: p.slice(3).trim() });
      } else if (p.indexOf('PS ') === 0) {
        out.push({ bucket: 'kids', value: p.slice(3).trim() });
      } else if (p.indexOf('TD ') === 0) {
        out.push({ bucket: 'kids', value: p.slice(3).trim() });
      } else if (/Y$/.test(p) && p !== 'GREY') {
        // "5Y" -> kids 5Y AND mens 5
        out.push({ bucket: 'kids', value: p });
        out.push({ bucket: 'mens', value: p.replace(/Y$/, '').trim() });
      } else if (/^(XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL)$/.test(p)) {
        out.push({ bucket: 'clothing', value: p });
      }
    });
    return out;
  }

  var requested = [];
  sizeParams.forEach(function (lbl) {
    parseSize(lbl).forEach(function (r) { requested.push(r); });
  });
  if (!requested.length) return;

  function readPipeList(card, attr) {
    var raw = card.getAttribute(attr) || '';
    if (!raw) return [];
    return raw.split('|').filter(function (x) { return x.length > 0; });
  }

  function numEq(a, b) {
    var na = parseFloat(a), nb = parseFloat(b);
    if (isNaN(na) || isNaN(nb)) return String(a).toUpperCase() === String(b).toUpperCase();
    return Math.abs(na - nb) < 0.01;
  }

  function cardMatches(card) {
    // For EACH requested size, check the matching IN-STOCK bucket on the card.
    // Card matches if ANY requested size is in stock here (union).
    for (var i = 0; i < requested.length; i++) {
      var r = requested[i];
      var instock = readPipeList(card, 'data-supra-sizes-' + r.bucket + '-instock');
      for (var j = 0; j < instock.length; j++) {
        if (numEq(instock[j], r.value)) return true;
      }
    }
    return false;
  }

  var cards = grid.querySelectorAll('[data-supra-card]');
  var visible = 0, hidden = 0;
  cards.forEach(function (card) {
    if (cardMatches(card)) {
      card.style.display = '';
      visible++;
    } else {
      card.style.display = 'none';
      hidden++;
    }
  });

  // Update the count display (if present) to reflect the in-stock-narrowed total
  var countEl = document.querySelector('.supra-coll__count, [data-supra-coll-count]');
  if (countEl && visible !== cards.length) {
    var page = visible + ' of ' + cards.length + ' in stock for selected size';
    var existing = countEl.textContent.trim();
    countEl.textContent = page;
    countEl.setAttribute('data-supra-original-count', existing);
  }

  // If the page is now totally empty post-filter, surface a friendly empty state
  if (visible === 0) {
    var existingEmpty = grid.querySelector('.supra-coll__empty--instock');
    if (!existingEmpty) {
      var div = document.createElement('div');
      div.className = 'supra-coll__empty supra-coll__empty--instock';
      div.style.gridColumn = '1 / -1';
      div.innerHTML =
        '<p class="supra-coll__empty-text">No products in stock for the selected size.</p>' +
        '<p class="supra-coll__empty-sub">Try a different size or remove the size filter.</p>';
      grid.appendChild(div);
    }
  }
})();
